import Vue from 'vue';
import VueModal from 'vue-js-modal';

export default {
    init() {
        Vue.use(VueModal, {
            dialog: true,
        });
    },
};
